import { all, call, takeLatest } from 'redux-saga/effects'

import { courseService } from 'page-modules/courses/service'

import { LOAD_ASSESSMENT_DETAILS_PAGE_DATA } from './actions'
import { getAssessmentService } from './index'
import type { AssessmentResponse } from './index'

export function* loadAssessmentPageDataSaga({
  payload: { assessmentSlug, req },
}: {
  payload: { assessmentSlug: string; req?: unknown }
}): Generator<unknown, void, unknown> {
  const assessment = (yield call(
    getAssessmentService.requestSaga as (arg: {
      payload: { req?: unknown; urlParams: string }
    }) => Generator,
    { payload: { req, urlParams: assessmentSlug } },
  )) as AssessmentResponse
  yield call(
    courseService.requestSaga as (arg: {
      payload: { req?: unknown; urlParams: { id: string } }
    }) => Generator,
    { payload: { req, urlParams: { id: assessment.course_id } } },
  )
}

export default function* saga(): Generator<unknown, void, unknown> {
  yield all([
    // @ts-expect-error redux-saga string action type
    takeLatest(LOAD_ASSESSMENT_DETAILS_PAGE_DATA, loadAssessmentPageDataSaga),
  ])
}
